import { createStyles } from "@mantine/core"

export const useStyles = createStyles((theme, { isSingleError }: { isSingleError: boolean }) => ({
    summaryItem: {
        color: theme.colors.gray[8],
        listStyle: isSingleError ? "none" : "inherit",
    },
}))
